import { Link } from 'react-router-dom';

export default function CTAInfluencer() {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-amber-50 via-rose-50 to-orange-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="bg-gradient-to-br from-amber-600 via-rose-600 to-orange-600 rounded-3xl p-12 shadow-2xl text-white">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-6 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-star-line text-lg"></i>
            Comece Agora
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            Pronta para Transformar Vidas e Ganhar Comissões?
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed max-w-2xl mx-auto">
            Junte-se a centenas de influencers que já estão impactando suas comunidades e gerando renda extra com o Método Bia Holmes! 💛
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <a 
              href="#formulario"
              className="inline-flex items-center gap-3 bg-white text-amber-700 px-8 py-4 rounded-xl text-lg font-bold hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-user-add-line text-2xl"></i>
              Quero Ser Parceira
            </a>
            <Link 
              to="/influencer/materiais"
              className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-4 rounded-xl text-lg font-bold hover:bg-white/20 transition-all whitespace-nowrap"
            >
              <i className="ri-gift-line text-2xl"></i>
              Ver Materiais Prontos
            </Link>
          </div>
          <div className="flex items-center justify-center gap-8 text-white/90">
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-2xl"></i>
              <span className="font-semibold">Sem Investimento</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-2xl"></i>
              <span className="font-semibold">Comissão de 30%</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-2xl"></i>
              <span className="font-semibold">Suporte Total</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}